// src/composables/useSubscription.js
import { ref } from 'vue';
import { billing } from '@/models/billing';

// Estado compartilhado entre telas: busca a situação da assinatura uma vez
// por carregamento do app (refresh() após um pagamento).
const subscription = ref(null);
let carregando = null;

export function useSubscription() {
  async function refresh() {
    try {
      const data = await billing().getOne();
      subscription.value = data.subscription;
    } catch (e) {
      // sem a informação, simplesmente não mostra o aviso
    }
    carregando = null;
    return subscription.value;
  }

  function load() {
    if (subscription.value) return Promise.resolve(subscription.value);
    if (!carregando) carregando = refresh();
    return carregando;
  }

  return { subscription, load, refresh };
}
